import "./RegisterPageLeft.scss";
import JAGIcon from "../icons/JAGIcon";
import StarIcon from "../icons/StarIcon";
import regHero from "../../img/RegHero.png";
import { Quote } from "../../util/types";
import { useEffect, useMemo, useState } from "react";
import { drdFlowState, planTypeState, popmenuFlowState, regStepState } from "../../state/atoms";
import { useRecoilValue } from "recoil";
import lakeBrakenCC from "../../img/lake-bracken-cc.png";
import qbLogoWhite from "../../img/qb-logo-white.png";
import fort from "../../img/fort.png";
import CompassLogo from "../icons/CompassLogo";
import { RegStep } from "./RegisterPage";
import ProStarFilledIcon from "../icons/ProStarFilledIcon";
import Checkmark from "../icons/Checkmark";
import DesignPlanIcon from "../icons/DesignPlanIcon";

interface Props {
  register?: boolean;
  step: RegStep;
}

const QUOTES = [{
  text: "“Selecting MustHaveMenus was far and away the strongest choice.”",
  icon: <JAGIcon />
}, {
  text: "“MustHaveMenus has been a game-changer for us.”",
  icon: <img src={lakeBrakenCC} alt={""} />
}, {
  text: "“MustHaveMenus is the ultimate solution for menu design, template selection, and seamless menu creation.”",
  icon: <img src={qbLogoWhite} alt={""} />
}, {
  text: <>“The program is user friendly and the customer service response time<br />is super quick. It’s made my life a lot easier!”</>,
  icon: <CompassLogo />
}, {
  text: "“What a lifesaver MustHaveMenus has been!”",
  icon: <img src={fort} alt={""} />
}] as Quote[];


const PRO_FEATURES = [
  'Extend with Digital Signage Manager',
  'Item library menu management',
  'POS menu data with sync',
  'AI Copilot',
  'Mobile menu builder app',
  'Unlimited hi-res downloads',
  'Unlimited team members',
  'User permissions and roles',
  'Priority customer support',
];

const DESIGN_FEATURES = [
  <>Design, edit, download, and print menus and<br/>marketing materials for a single restaurant location</>,
  '23,000+ hospitality-ready design templates',
  'Design, Edit, Download as PNG, PDF, JPG',
  'Print and ship to your doorstep',
  'Share links to use anywhere',
  'Organize with folders',
  '5M+ photos and graphics',
  'PDF download w/full bleed',
  'Premium web image download',
  'Apply brand font, colors, logos',
  'Unlimited QR Code views',
];


const POPMENU_FEATURES = [
  'Bring your menus right in',
  'No retyping, no errors',
  'Point-n-click to add menu groups to designs'
];

export default function RegisterPageLeft({ register, step }: Props) {
  const regStep = useRecoilValue(regStepState);
  const popmenuFlow = useRecoilValue(popmenuFlowState);
  const drdFlow = useRecoilValue(drdFlowState);
  const [currentQuote, setCurrentQuote] = useState(QUOTES[0]);
  const planType = useRecoilValue(planTypeState);

  useEffect(() => {
    setCurrentQuote(QUOTES[regStep]);
  }, [regStep]);

  const headerText = useMemo(() => {
    if (popmenuFlow) return <>Welcome<br/>Popmenu Customers!</>;
    if (drdFlow) return <>Welcome<br/>DiningRD users!</>;
    if (register) return <>Let's get started!</>;
    return <>Let's get started!</>;
  }, [drdFlow, popmenuFlow, register]);

  return <div className={`reg-left ${(step === RegStep.PlanSetup && planType) ? 'plans' : ''}`}>
    {(step !== RegStep.PlanSetup || !planType) && <>
      <header>
        <span>{currentQuote.text}</span>
        {currentQuote.icon}
      </header>
      <section>
        <div className={"stars"}>
          <StarIcon />
          <StarIcon />
          <StarIcon />
          <StarIcon />
          <StarIcon />
        </div>
        <span>The All-In-One Restaurant Menu Solution</span>
        <img src={regHero} alt={"Reg Hero"} />
        <h1 className={`popmenu ${drdFlow ? 'drd' : ''}`}>{headerText}</h1>
        {!popmenuFlow && !drdFlow && <h3>Loved by more than 10,000 restaurants!</h3>}
        {popmenuFlow && <>
          <span className={'popmenu-header'}>Our integration with Popmenu offers:</span>
          <div className={'features popmenu'}>
            {POPMENU_FEATURES.map((it) => <div key={it}>
              <div>
                <Checkmark/>
                <span>{it}</span>
              </div>
            </div>)}
          </div>
        </>}
      </section>
    </>}
    {(step === RegStep.PlanSetup && planType) && <>
      <header><img src={regHero} alt={"Reg Hero"} /></header>
      {planType === "pro" && <section>
        <h1><ProStarFilledIcon /> Pro Plan</h1>
        <h3>With MustHaveMenus Pro, you get everything in the<br/>Design Plan, plus:</h3>
        <div className={'features'}>
          {PRO_FEATURES.map((it) => <div key={it}>
            <div>
              <Checkmark/>
              <span>{it}</span>
            </div>
          </div>)}
        </div>
      </section>}
      {planType === "design" && <section>
        <h1><DesignPlanIcon /> Design Plan</h1>
        <h3>Design and print everything for your restaurant.</h3>
        <div className={'features'}>
          {DESIGN_FEATURES.map((it, i) => <div key={i}>
            <div>
              <Checkmark/>
              <span>{it}</span>
            </div>
          </div>)}
        </div>
      </section>}
    </>}
  </div>;
}
